// Hidden component that exposes formatted offer data
// via data-insider-* attributes.
// Used by Insider's custom selectors from their crawler to fetch.
// Should not ever be visible to users.
//
// `insider-selectors-config.json` is a visual representation of the selectors
// configured in Insider's platform. This JSON file serves two purposes:
// 1. Backup of the Insider configuration in our repo
// 2. Easy way to update Insider's variables by uploading the JSON directly
//
// When adding/changing selectors in this component, update the JSON file
// and upload it to Insider using the following steps:
// 1. Go to: https://promobit.inone.useinsider.com/email/3655/designV2?variation=7816
// 2. On Email Design > Edit
// 3. Click the main content > Data > Configuration > JSON Editor
// 4. Paste the contents of `insider-selectors-config.json`
// 5. Click the "Save" button
import PropTypes from 'prop-types';

import { getOfferImageLink } from 'lib/image';
import { formatAsBRLWithSignal } from 'lib/number';

const LOWEST_PRICE_TAG_NAME = 'Menor preço';

const InsiderData = ({
  offerTitle,
  offerPhoto,
  offerOldPrice,
  offerPrice,
  offerCoupon,
  offerLikes,
  offerCommentsCount,
  offerTags = [],
  storeName,
  userName,
}) => {
  const hasLowestPriceTag = offerTags?.some(
    (tag) => tag.name === LOWEST_PRICE_TAG_NAME
  );

  return (
    <div aria-hidden="true" data-insider-container="offer" hidden>
      <span data-insider-item="offer-title">{offerTitle}</span>
      <span data-insider-item="offer-image">
        {getOfferImageLink(offerPhoto, 200)}
      </span>
      <span data-insider-item="store-name">{storeName}</span>
      <span data-insider-item="offer-old-price">
        {offerOldPrice ? formatAsBRLWithSignal(offerOldPrice) : ''}
      </span>
      <span data-insider-item="offer-price">
        {offerPrice ? formatAsBRLWithSignal(offerPrice) : ''}
      </span>
      <span data-insider-item="offer-coupon">{offerCoupon || ''}</span>
      <span data-insider-item="user-name">{userName}</span>
      <span data-insider-item="offer-likes">{offerLikes}</span>
      <span data-insider-item="offer-comments">{offerCommentsCount}</span>
      <span data-insider-item="offer-tag">
        {hasLowestPriceTag ? 'Menor preço' : ''}
      </span>
    </div>
  );
};

InsiderData.propTypes = {
  offerCommentsCount: PropTypes.number,
  offerCoupon: PropTypes.string,
  offerLikes: PropTypes.number,
  offerOldPrice: PropTypes.number,
  offerPhoto: PropTypes.string,
  offerPrice: PropTypes.number,
  offerTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ),
  offerTitle: PropTypes.string,
  storeName: PropTypes.string,
  userName: PropTypes.string,
};

export default InsiderData;
